// extracted by mini-css-extract-plugin
export default {"contentCard":"PlayerProfileContentCard_contentCard__f4DDb","contentPage":"PlayerProfileContentCard_contentPage__qe3aD"};